import { render, staticRenderFns } from "./octocat.vue?vue&type=template&id=e198c6b8&"
import script from "./octocat.vue?vue&type=script&lang=js&"
export * from "./octocat.vue?vue&type=script&lang=js&"
import style0 from "./octocat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports